import cn from "classnames";
import type { BucketFilter, ModeFilter } from "./shipments.model";
import { BUCKET_LABELS, MODE_LABELS, SHIPMENT_BUCKETS } from "./shipments.model";

type ShipmentFiltersProps = {
  bucket: BucketFilter;
  mode: ModeFilter;
  onBucketChange: (bucket: BucketFilter) => void;
  onModeChange: (mode: ModeFilter) => void;
};

const BUCKETS: BucketFilter[] = ["all", ...SHIPMENT_BUCKETS];

const MODES: ModeFilter[] = ["all", "ocean", "air"];

/**
 * The pill bar, plus the native select it collapses into on narrow screens.
 * Both are always rendered — CSS decides which one is visible, so the two
 * never disagree about the selected bucket.
 */
export const ShipmentFilters = ({ bucket, mode, onBucketChange, onModeChange }: ShipmentFiltersProps) => (
  <div className="pcsh__fbar">
    <label className="pcf pcsh__fsel">
      <select
        value={bucket}
        onChange={(event) => onBucketChange(event.target.value as BucketFilter)}
        aria-label="Filter shipments"
      >
        {BUCKETS.map((key) => (
          <option key={key} value={key}>
            {BUCKET_LABELS[key]}
          </option>
        ))}
      </select>
    </label>

    <div className="pcsh__f pcsh__f--wide" role="group" aria-label="Filter shipments">
      {BUCKETS.map((key) => (
        <button
          key={key}
          type="button"
          className={cn("pcsh__fb", { "is-on": bucket === key })}
          data-filter={key}
          aria-pressed={bucket === key}
          onClick={() => onBucketChange(key)}
        >
          {BUCKET_LABELS[key]}
        </button>
      ))}
    </div>

    <div className="pcsh__f pcsh__f--mode" role="group" aria-label="Transport mode">
      {MODES.map((key) => (
        <button
          key={key}
          type="button"
          className={cn("pcsh__fb", { "is-on": mode === key })}
          aria-pressed={mode === key}
          onClick={() => onModeChange(key)}
        >
          {MODE_LABELS[key]}
        </button>
      ))}
    </div>
  </div>
);
